<template>
    <div>
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline" label-position="left">
                <el-form-item label="客户名称：">
                    <el-input size="small" v-model.trim="formInline.company" maxlength="60"  clearable placeholder="用户名称" @change="search" style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="reset" icon="Refresh">重置</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="add" type="success" icon="Plus">新增</el-button></el-form-item>
            </el-form>
        </div>
        <div>
            <el-table :height="'calc('+(tableHeight)+'px)'" stripe :data="tableData" ref="tableref" v-loading="loadingPage" style="width:100%">
                <el-table-column type="index" width="70" align="center" label="序号">
                    <template #default="scope">
                        <span>{{ getIndex(scope.$index) }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="110" prop="company" label="客户名称"></el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template #default="scope">
                        <el-button size="small" link type="primary" @click="edit(scope.row)" icon="Edit"></el-button>
                        <el-button size="small" link type="danger" @click="remove(scope.row.id)" icon="Delete"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog v-model="dialogVisible" :close-on-click-modal="false" :title="loadingTitle" width="560px" :before-close="cancel">
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto">
                <el-form-item label="客户名称" prop="company">
                    <el-input v-model="formData.company"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="cancel()">取消</el-button>
                <el-button type="primary" @click="isEdit?editSubmit(formData.id):submitData()">确定</el-button>
            </template>
        </el-dialog>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination";
    import {getCustomerList,newCustomer,deleterCustomer,editCustomer} from '@/api/api'
    import {getTableHeight} from "@/utils/util";
    export default {
        components:{
            Pagination
        },
        name:'customerManage',
        data() {
            return {
                loadingPage:false,
                tableHeight:500,
                formInline:{
                    company:'',
                    page: 1,
                    limit:20,
                },
                loadingTitle:'新增客户名称',
                dialogVisible:false,
                formData:{
                    company:''
                },
                isEdit:false,
                pageparm: {
                    page: 1,
                    limit:20,
                    total: 0
                },
                tableData:[],
                rules: {
                    company: [
                        { required: true, message: '请输入客户名称', trigger: 'change' }
                    ],
                },
            }
        },

        methods:{
            //获取列表
            async getData() {
                this.loadingPage = true
                getCustomerList(this.formInline).then(res => {
                     this.loadingPage = false
                     if(res.code ==2000) {
                         this.tableData = res.data.data
                         this.pageparm.page = res.data.page;
                         this.pageparm.limit = res.data.limit;
                         this.pageparm.total = res.data.total;
                     }
                 })
            },
            // 表格序列号
            getIndex($index) {
                // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
                return (this.pageparm.page-1)*this.pageparm.limit + $index +1
            },
            // 新增保存linker
            submitData(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        newCustomer(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            editSubmit(){
                this.$refs.rulesForm.validate((valid) => {
                    if (valid) {
                        editCustomer(this.formData).then(res=>{
                            if(res.code==2000){
                                this.$message.success(res.msg);
                                this.dialogVisible=false;
                                this.getData();
                            }else{
                                this.$message.error(JSON.stringify(res.msg));
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            add(){
                this.cancel();
                this.dialogVisible=true;
                this.isEdit=false;
                this.loadingTitle="新增客户名称"
            },
            // 编辑linker账号
            edit(obj){
                this.formData=JSON.parse(JSON.stringify(obj));
                this.dialogVisible=true;
                this.isEdit=true;
                this.loadingTitle="编辑客户名称"
            },
            // 删除linker账号 
            remove(id){
                this.$confirm('确定删除吗？','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消'
                }).then(()=>{
                    deleterCustomer({id:id}).then(res=>{
                        if(res.code==2000){
                            this.$message.success(res.msg);
                            this.dialogVisible=false;
                            this.getData();
                        }else{
                            this.$message.error(JSON.stringify(res.msg));
                        }
                    })
                }).catch(err=>{})
            },
            cancel(){
                this.formData={
                    company:''
                };
                this.isEdit=false;
                this.dialogVisible=false;
            },
            reset() {
                this.formInline = {
                    company:'',
                    page:1,
                    limit:20
                }
                this.pageparm={
                    page: 1,
                    limit:20,
                    total: 0
                }
                this.getData()
            },
            callFather(parm) {
                this.formInline.page = parm.page
                this.formInline.limit = parm.limit
                this.getData()
            },
            search() {
                this.formInline.page = 1
                this.formInline.limit =20
                this.getData()
            },
            // 计算搜索栏的高度
            listenResize() {
				this.$nextTick(() => {
				    this.getTheTableHeight()
				})
			},
            getTheTableHeight(){
                let tabSelectHeight = this.$refs.tableSelect?this.$refs.tableSelect.offsetHeight:0
                tabSelectHeight = this.isFull?tabSelectHeight - 110:tabSelectHeight
                this.tableHeight =  getTableHeight(tabSelectHeight)
            },
        },
        created() {
            this.getData()
        },
        mounted() {
            // 监听页面宽度变化搜索框的高度
            window.addEventListener('resize', this.listenResize);
            this.$nextTick(() => {
              this.getTheTableHeight()
            })
        },

        unmounted() {
             // 页面销毁，去掉监听事件
			window.removeEventListener("resize", this.listenResize);
        },
    }
</script>
